import { render, staticRenderFns } from "./NtagTags.vue?vue&type=template&id=21ba9279&scoped=true&"
import script from "./NtagTags.vue?vue&type=script&lang=ts&"
export * from "./NtagTags.vue?vue&type=script&lang=ts&"
import style0 from "./NtagTags.vue?vue&type=style&index=0&id=21ba9279&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ba9279",
  null
  
)

export default component.exports